import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import { 
    Radio, 
    RadioGroup, 
    FormControlLabel, 
    FormLabel,
    FormControl,
    Button,
    Box,
    InputLabel,
    Typography,
    TextareaAutosize 
} from '@material-ui/core';

import './PermitDetail.scss'

import { 
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    FileInput,
    Footer
} from '../../components/_index'
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { useYupValidationResolver } from '../../YupValidationResolver';
import Scroll from 'react-scroll';
import { checkIfRedirect, isEmpty, isObjectEmpty, uploadFiles } from '../../utils';
import errorWarning from '../../images/icon_warning.gif'

export default withTranslation()(function PermitDetail({t}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const { arrCount, setArrCount } = useState(0);
    const history = useHistory();

    checkIfRedirect(data, history);
   
    let vehArr = data.vehicleGp;
    function maxArrNo (vehArr) {
        console.log('maxArrNo vehArr: ', vehArr)
        let length = vehArr.length
        console.log("maxArrNo length: ", length)
        if (!vehArr) {
           return 
        } else {
            return length 
        }
    }

    

    const schema = yup.object().shape({
        iWant: yup.string().required(t("errors.frontend.790-E-0601")),
        numPermit: yup.number().when('iWant', {
            is: (val) => val === 'bulk',
            then: yup.number()
                .min(1, t("errors.frontend.790-E-0602"))
                .integer(t("errors.frontend.790-E-0603"))
                .typeError(t("errors.frontend.790-E-0604"))
                .test('is-too-long', t("errors.frontend.790-E-0605"), (value) => {
                    return value <= maxArrNo(vehArr)
                }),
            otherwise: yup.number().notRequired()
        }),
        remarks: yup.string()
            .ensure()
            .when(['iWant', 'remarkFiles'] , {
                is: (iWant, remarkFiles) => (iWant == "others" && remarkFiles?.length == 0),
                // is: (x, remarkFiles) => console.log("remarks(validator) iWant, remarkFiles: ", {x, remarkFilesSelected, remarkFiles}),
                then: yup.string().ensure().required(t("errors.frontend.790-E-0606")),
                otherwise: yup.string()
        }),
    }, [[ 'remarks', 'remarkFiles', 'iWant' ]] );

    const { 
        register,
        handleSubmit, 
        control, 
        errors,
        clearErrors,
        reset,
        watch,
        getValues,
        setValue,
        onChange,
    } = useForm({
        defaultValues: { 
            iWant: data.iWant || 'one',
            numPermit: isEmpty(data.numPermit)?"":data.numPermit,
            remarks: isEmpty(data.remarks)?"":data.remarks
        },
        mode: "onSubmit",
        resolver: yupResolver(schema),
    });

    const iWantSelected = watch('iWant');
    const remarksSelected = watch('remarks');
    const remarkFilesSelected = watch('remarkFiles');

    console.log('watch: ', {iWantSelected,remarksSelected,remarkFilesSelected});

    const onSubmit = (data) => {
        console.log(data);
        setValues(data);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/applicationDetail`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
    }

    useEffect(() => {
        scroll.scrollToTop();
    }, []);
    
    const handleReset = () => {
        scroll.scrollToTop();
    	clearErrors();
        let newState = {
            iWant: "",
            remarks: "",
            remarkFiles: [],
        }
        setValues(newState);

        reset({
            iWant: 'one',
            numPermit: '',
            remarks: '',
            remarkFiles: [],
        })
    }

    const handleState = (remarkFiles) => {
        setValues({remarkFiles: remarkFiles});
    };
    const handleBack = () => {
        if (data.applicationType === 'Duplicate') history.push("./selectService");
		else history.push(`${process.env.REACT_APP_SUB_ROUTE}/locationDetail`);
    }
    console.log('getValues:', getValues())
    // console.log('data:', data)
    console.log("errors: ", errors)
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-007'}</title>
            </Helmet>
            <Box className="wrapper permitDetail">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step3" />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={errors} />
                        <StepHeader 
                            step="common.step3" 
                            title="step3.permitTitle"
                            mandatory
                        />
                        <form onSubmit={handleSubmit(onSubmit, onError)} onReset={handleReset} noValidate>
                            <FormBox header="step3.permitDetail.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <FormControl 
                                            component="fieldset" 
                                            error={!!errors.iWant}
                                        >
                                            <FormLabel 
                                                component="legend" 
                                            >
                                                {t('step3.reviewApplication.iWant')} 
                                                <Box component="span" className="danger">*</Box>
                                            </FormLabel>
                                            <Controller
                                                control={control}
                                                name="iWant"
                                                defaultValue={data.iWant}
                                                as={
                                                    <RadioGroup 
                                                        aria-label="iWant" 
                                                    >
                                                        <FormControlLabel 
                                                            value="one" 
                                                            control={<Radio />} 
                                                            label={t('step3.reviewApplication.iWantOpt1')}
                                                        />
                                                        <FormControlLabel 
                                                            value="bulk" 
                                                            control={<Radio />} 
                                                            label={t('step3.reviewApplication.iWantOpt2')}
                                                        />
                                                        <FormControlLabel 
                                                            value="others" 
                                                            control={<Radio />} 
                                                            label={t('step3.reviewApplication.iWantOpt3')}
                                                        />
                                                    </RadioGroup>
                                                }
                                            />
                                            {!!errors.iWant ? <img id="iWant_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                        </FormControl>
                                        {
                                            (iWantSelected === 'bulk' ||
                                            iWantSelected === 'others') &&
                                            process.env.REACT_APP_PHASE !== "1" &&
                                            <ul>
                                                <li>{t('step3.reviewApplication.noticesMsg')}</li>
                                            </ul>
                                        }
                                    </Box>
                                    {
                                        iWantSelected === 'bulk' &&
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.numPermit}
                                            >
                                                <InputLabel shrink htmlFor="numPermit">
                                                    {t('step3.reviewApplication.numPermit')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <BootstrapInput
                                                    id="numPermit"
                                                    name="numPermit"
                                                    defaultValue={data.numPermit}
                                                    ref={register()}
                                                />
                                                {!!errors.numPermit ? <img id="numPermit_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                            </FormControl>
                                        </Box>
                                    }
                                    {
                                        iWantSelected === 'others' &&
                                        <>
                                            <Box mb={6}>
                                                <FormControl
                                                    error={!!errors.remarks}
                                                >
                                                    <InputLabel shrink htmlFor="remarks">
                                                        {t('step3.reviewApplication.remarks')} <Box component="span" className="danger">*</Box>
                                                    </InputLabel>
                                                    <TextareaAutosize 
                                                        id="remarks"
                                                        name="remarks"
                                                        defaultValue={data.remarks}
                                                        rowsMin={5}
                                                        ref={register()}
                                                    />
                                                    {!!errors.remarks ? <img id="remarks_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                </FormControl>
                                            </Box>
                                        </>
                                    }
                                    
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        type="reset" 
                                        className="secBtn"
                                    >
                                        {t('common.button.clear')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        type="submit"
                                    >
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
